var _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarnNavDiscoverInactive = function SvgEarnNavDiscoverInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.335,
    cy: 9.833,
    r: 7.542,
    transform: "rotate(-45 10.335 9.833)",
    fill: "#fff",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.334 3.833a8.485 8.485 0 0 0 11.297 12.63l3.036 3.037 1.334-1.333-3.037-3.037A8.487 8.487 0 0 0 4.334 3.833Zm1.333 1.334a6.6 6.6 0 1 1 9.334 9.333 6.6 6.6 0 0 1-9.334-9.333Z",
    fill: "#D8D8D8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19.833,
    width: 4.714,
    height: 8.485,
    rx: 2.357,
    transform: "rotate(-45 17 19.833)",
    fill: "#999"
  })));
};
export default SvgEarnNavDiscoverInactive;